package components.project.configuration.pricestrend

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.configuration.components.Einspeiseart
import it.neckar.lizergy.model.configuration.energy.power.PricesTrendScenario
import it.neckar.lizergy.model.energy.economics.PricePerKWh
import it.neckar.open.kotlin.lang.percent
import it.neckar.open.kotlin.lang.roundDecimalPlacesHalfUp
import it.neckar.open.unit.currency.ct
import it.neckar.open.unit.other.pct100
import it.neckar.open.unit.time.pa
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import react.*
import react.dom.*

val EditPricesTrend: FC<EditPricesTrendProps> = fc("EditPricesTrend") { props ->
  val pricesTrendScenarioToSave = props::pricesTrendScenarioToSave.getNotNull()
  val fallbackGuaranteedFeedInPrice = props::fallbackGuaranteedFeedInPrice.safeGet()
  val einspeiseart = props::einspeiseart.safeGet()
  val editableStatus = props::editableStatus.safeGet()

  val pricesTrendScenario = pricesTrendScenarioToSave.value

  @ct val guaranteedFeedInPrice = useState(pricesTrendScenario.guaranteedFeedInPrice?.price?.cents?.roundDecimalPlacesHalfUp(2))
  @ct val consumptionPrice = useState(pricesTrendScenario.consumptionPrice.price.cents)
  @pa @pct100 val consumptionPriceIncreasePercentage = useState(pricesTrendScenario.consumptionPriceIncreasePercentage * 100)


  useEffect(guaranteedFeedInPrice.value, consumptionPrice.value, consumptionPriceIncreasePercentage.value) {
    pricesTrendScenarioToSave.setter(
      PricesTrendScenario(
        guaranteedFeedInPrice = guaranteedFeedInPrice.value?.let { PricePerKWh.cents(it) },
        consumptionPrice = PricePerKWh.cents(consumptionPrice.value),
        consumptionPriceIncreasePercentage = consumptionPriceIncreasePercentage.value.percent,
      )
    )
  }


  div("my-4") {

    h4 {
      +"Strompreise"
    }

    pricesTrendScenarioForm(
      guaranteedFeedInPrice = guaranteedFeedInPrice,
      consumptionPrice = consumptionPrice,
      consumptionPriceIncreasePercentage = consumptionPriceIncreasePercentage,
      fallbackGuaranteedFeedInPrice = fallbackGuaranteedFeedInPrice,
      einspeiseart = einspeiseart,
      editableStatus = editableStatus,
    )
  }

}


external interface EditPricesTrendProps : Props {
  var pricesTrendScenarioToSave: StateInstance<PricesTrendScenario>
  var fallbackGuaranteedFeedInPrice: PricePerKWh
  var einspeiseart: Einspeiseart
  var editableStatus: EditableStatus
}
